"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _upload = _interopRequireDefault(require("cccisd-icons/upload5"));
var _AssetPicker = _interopRequireDefault(require("../../../AssetPicker"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Component = /*#__PURE__*/function (_React$Component) {
  _inherits(Component, _React$Component);
  var _super = _createSuper(Component);
  function Component() {
    var _this;
    _classCallCheck(this, Component);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (!_this.props.editing) {
        _this.setDefaultThumbnail();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "setDefaultThumbnail", function () {
      var type = _this.props.type;
      var thumbObj = {
        id: type.file_id,
        folderId: type.file.folder_id,
        name: type.file.filename,
        thumbnailSmall: type.file.thumbnail.small_url
      };
      _this.props.field.onChange(thumbObj);
    });
    _defineProperty(_assertThisInitialized(_this), "onSelectFile", function (selectedFile) {
      _this.props.field.onChange(selectedFile);
      _this.modal.close();
    });
    _defineProperty(_assertThisInitialized(_this), "getThumbnailUrl", function () {
      if (_this.props.field.value === null) {
        return _this.props.type.file.thumbnail.small_url;
      }
      if (_this.props.field.value.thumbnailSmall) {
        return _this.props.field.value.thumbnailSmall;
      }
      return _this.props.field.value;
    });
    return _this;
  }
  _createClass(Component, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: this.props.field,
        label: "Resource Thumbnail"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: 'text-center ' + _style["default"].manager
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].thumbWrapper
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].thumbImage,
        style: {
          backgroundImage: "url(".concat(this.getThumbnailUrl(), ")")
        }
      })), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        size: "large",
        title: "Upload thumbnail",
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-default"
        }, /*#__PURE__*/_react["default"].createElement(_upload["default"], {
          spaceRight: true
        }), "Upload"),
        ref: function ref(elem) {
          _this2.modal = elem;
        }
      }, /*#__PURE__*/_react["default"].createElement(_AssetPicker["default"], {
        globalFilter: "image",
        render: function render(_ref) {
          var body = _ref.body,
            selectedFile = _ref.selectedFile;
          return /*#__PURE__*/_react["default"].createElement("div", null, body, /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              marginTop: '1em'
            }
          }, /*#__PURE__*/_react["default"].createElement("button", {
            type: "button",
            className: "btn btn-primary",
            disabled: !selectedFile,
            onClick: _this2.onSelectFile.bind(_this2, selectedFile)
          }, "Select image")));
        }
      }))));
    }
  }]);
  return Component;
}(_react["default"].Component);
exports["default"] = Component;
_defineProperty(Component, "propTypes", {
  field: _propTypes["default"].object,
  type: _propTypes["default"].object.isRequired,
  editing: _propTypes["default"].bool
});